(function($){
    $(function(){  //document.ready        

      $('#pwFormVino').on('submit', function(e){
        var pwInput = $('#input-password').val();
        var pwInputText = $('#input-password-text').val();
        //additional pws for licenses
        var regexCheck0 = pwInput.search(new RegExp(regexPhrase+'[A-Z]{1}[0-9]{6}$'));
       	var regexCheck1 = pwInput.search(new RegExp(regexPhrase+'[A-Z]{1}[0-9]{6}$'));

       if (
            pwInput === actualPw || pwInputText === actualPw ||
            pwInput === actualPw1 || pwInputText === actualPw1 ||
            pwInput === actualPw2 || pwInputText === actualPw2 ||
            pwInput === actualPw3 || pwInputText === actualPw3 ||
            pwInput === actualPw4 || pwInputText === actualPw4 ||         
         	regexCheck0 >= 0 ||
         	regexCheck1 >= 0 
         ) {
                  $('#WorkoutOverlayPw').addClass('hide');
                  e.preventDefault();
              e.stopPropagation();
          } else {
              $('#alert-invalid-password').removeClass('hide');
              e.preventDefault();
              e.stopPropagation();
          }
      });
    });

})(jQuery);